import type { Video } from '../../hydration/WPVideo/types';
import type { IVideoOptions } from './types';

export const getVideoUrl = (id: string, options: IVideoOptions) => {
  const queryParams = new URLSearchParams({
    autoplay: options.showPreview === false ? '0' : '1',
    rel: options.showRelatedVideos ? '1' : '0',
    color: 'white',
  });
  return `https://www.youtube.com/embed/${id}?${queryParams.toString()}`;
};

export const getWebPImageUrl = (imageUrl: string): string =>
  (imageUrl && imageUrl.replace('/vi/', '/vi_webp/').replace('.jpg', '.webp')) || imageUrl;

export const getVideoImageSRC = (video: Video) => {
  const thumbnails = video?.youtubeVideo?.snippet?.thumbnails;
  const videoId = video?.youtubeVideo?.id;

  return thumbnails
    ? getWebPImageUrl(thumbnails.standard.url)
    : `https://i.ytimg.com/vi_webp/${videoId}/mqdefault.webp`;
};

export const getVideoImageSRCSet = (video: Video) => {
  const thumbnails = video?.youtubeVideo?.snippet?.thumbnails;
  const videoId = video?.youtubeVideo?.id;

  return thumbnails
    ? `${getWebPImageUrl(thumbnails?.medium?.url)} 320w, ${getWebPImageUrl(
        thumbnails?.maxres?.url,
      )} 1280w, ${getWebPImageUrl(thumbnails?.default?.url)} 120w, ${getWebPImageUrl(
        thumbnails?.high?.url,
      )} 480w, ${getWebPImageUrl(thumbnails?.standard?.url)} 640w`
    : `https://i.ytimg.com/vi_webp/${videoId}/mqdefault.webp 320w, https://i.ytimg.com/vi_webp/${videoId}/maxresdefault.webp 1280w`;
};
